module.exports = require('./lib/syntax')
